<template>
  <div id="" class="header-popover">
    <!-- 修改密码 -->
    <el-dialog
      :visible.sync="visible"
      title="修改密码"
      width="800px"
      :lock-scroll="true"
      :center="true"
    >
      <el-form ref="passform" :model="passform" label-width="120px">
        <el-form-item
          label="原始密码"
          prop="oldPassword"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model="passform.oldPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          prop="newPassword"
          label="新密码"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model="passform.newPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          label="确认新密码"
          prop="newPassword1"
          :rules="[
            {
              validator: checkPassword,
              required: true,
              trigger: 'blur',
            },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model="passform.newPassword1"
            type="password"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelpass">取消</el-button>
        <el-button size="small" type="primary" @click="submitpass"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-container>
      <!-- 头部区域 -->
      <el-header class="header">
        <!-- 头部左侧区域 -->
        <div class="header_text">
          <div class="herder_text_left">
            <!-- <img class="logo" src="@/assets/img/login/logo.png" /> -->
            {{ schoolName?schoolName:'学生发展与综合素质评价平台' }}
          </div>
          <!-- <el-menu
            v-for="(item, index) in onePermissionsMenu"
            :key="index"
            mode="horizontal"
            router
            :default-active="'/' + activePath"
          >
            <el-menu-item
              :index="'/' + item.html"
              @click="setItemPath(item.html)"
              >{{ item.name }}</el-menu-item
            >
          </el-menu> -->
        </div>

        <!-- 导航 -->
        <div style="flex: 1; margin-left: 60px">
          <span
            @click="navTo(item)"
            :class="item.appId == 13 ? 'nowApp' : ''"
            style="cursor: pointer; margin-right: 25px"
            v-for="(item, index) in appList"
            :key="item.appId"
            ><i :class="icons[index % 3]" style="margin-right: 10px"></i
            >{{ item.appName }}</span
          >
        </div>

        <!-- 头部右侧区域 -->
        <div class="header_right">
          <!-- <div class="header_btny">
            <add-bookss
              v-show="roleType == 'teacher' ? true : false"
              class="header_btny"
            ></add-bookss>
          </div> -->
          <ul>
            <li
              @click="workTai"
              style="
                cursor: pointer;
                height: 60px;
                line-height: 60px;
                margin-right: 24px;
              "
            >
              工作台
            </li>
          </ul>

          <div class="hearder_right_user">
            <div class="img-box" v-if="roleType == 'teacher' ? true : false">
              <el-image
                class="imglogo"
                :src="hostUrl + userDatas.headPhotoUrl"
                fit="cover"
              >
                <div slot="error" class="image-slot">
                  <i
                    ><img
                      style="height: 40px"
                      v-if="userDatas.sex == 1"
                      src="../../assets/img/sex0.png"
                  /></i>
                  <i
                    ><img
                      style="height: 40px"
                      v-if="userDatas.sex == 0"
                      src="../../assets/img/默认头像.png" />
                    <i
                      ><img
                        style="height: 40px"
                        v-if="userDatas.sex == null"
                        src="../../assets/img/默认头像.png"
                        alt=""
                        srcset="" /></i
                  ></i>
                </div>
              </el-image>
            </div>

            <el-popover placement="bottom-end" trigger="hover">
              <div class="operation">
                <ul class="header_right_se">
                  <li
                    v-if="roleType == 'teacher' ? true : false"
                    @click="$router.push('/teacherbasic')"
                  >
                    <i class="icon el-icon-user" />
                    个人资料
                  </li>
                  <li @click="xgpassword">
                    <i class="icon el-icon-lock" />
                    修改密码
                  </li>
                  <li class="" @click="unLogin">
                    <i class="icon el-icon-lock" />
                    退出登录
                  </li>
                </ul>
              </div>
              <div slot="reference" class="nameBtn">
                {{ userDatas.name }}
                <i class="el-icon-caret-bottom"></i>
              </div>
            </el-popover>
          </div>
        </div>
      </el-header>
      <!-- 内容主体区域 -->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import addBookss from '../bench/components/addbook'
import {
  userpermissionsall,
  UserLogout,
  usercenterinfo,
  modifyPassWord,
  roleByUser,
  userpermissions,
  homeUrl,
  getAppList,
} from '@/api/home'
export default {
  components: {
    addBookss,
  },
  data() {
    return {
      // 一级权限菜单

      url: homeUrl, //统一跳转前置路径
      onePermissionsMenu: [],
      userData: [],
      schoolId: 0,
      userDatas: [],
      visible: false,
      roleType: '',
      appName: '',
      // roleTypes: localStorage.getItem('roleTypes'),
      // 处理默认高亮
      activePath: '',
      passform: {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',
      },
      times: '',
      token: '',
      classesVo: [],
      roleByUsers: [],
      roleId: '',
      appList: [],
      icons: ['el-icon-data-line', 'el-icon-document', 'el-icon-data-analysis'],
      schoolName:''
    }
  },
  watch: {},
  created() {
    this.token = this.$route.query.token
    this.roleId = this.$route.query.roleId
    if (this.token !== 'undefined' && this.token) {
      localStorage.setItem('token', this.token)
    }
    if (this.roleId !== 'undefined' && this.roleId) {
      localStorage.setItem('roleId', this.roleId)
    }
    this.roleId = localStorage.getItem('roleId')
    this.usercenterinfo()
    this.setItemPath()
    this.userpermissions()
    // 初始化时取出保存的页面路径
  },
  mounted() {
    this.getAppList()
  },
  methods: {
    //   获取当前用户登陆信息
    async usercenterinfo() {
      const { data: res } = await usercenterinfo()
      this.userData = res.data
      this.hostUrl = res.data.hostUrl
      localStorage.setItem('type', res.data.schoolType)
      this.schoolName=res.data.schoolName
      if (res.data.roleType == 'teacher') {
        this.userDatas = res.data.teacher
        this.roleType = res.data.roleType
        localStorage.setItem('schoolIds', res.data.teacher.schoolId)
        localStorage.setItem('roleType', res.data.roleType)
        localStorage.setItem('userId', res.data.teacher.id)
        if (res.data.teacher.classesVo && this.roleId == '-1003') {
          localStorage.setItem('classId', res.data.teacher.classesVo.id)
          localStorage.setItem('gradeId', res.data.teacher.classesVo.gradeId)
          this.$router.push('/school/classes?token=' + this.$route.query.token)
        }
        this.classesVo = res.data.teacher.classesVo
        this.roleByUser()
      } else if (res.data.roleType == 'school') {
        this.roleType = res.data.roleType
        localStorage.setItem('schoolIds', res.data.school.id)
        localStorage.setItem('userId', res.data.school.id)
        localStorage.setItem('roleType', res.data.roleType)
        this.userDatas = res.data.school
      }
    },
    //根据角色查询权限菜单
    async userpermissions() {
      const { data: res } = await userpermissions({
        roleId: this.roleId,
      })
      this.onePermissionsMenu = res.data
    },
    // // 调用用户权限接口
    // async userpermissionsall() {
    //   const { data: res } = await userpermissionsall({
    //     appCode: 'JCSJGL',
    //     parentId: 0,
    //   })
    //   this.onePermissionsMenu = res.data
    // },
    // 获取自己全部角色
    async roleByUser() {
      const { data: res } = await roleByUser()
      this.roleByUsers = res.data
      if (!this.classesVo && this.roleByUsers.length == 1) {
        this.$message.error('您没有进入权限哦，请联系管理员！！！')
        setTimeout(() => {
          let urlss = this.url + 'bench?token=' + localStorage.getItem('token')
          window.open(urlss, '_self')
        }, 500)
      }
    },

    // 处理默认高亮
    setItemPath(activePath) {
      const path = this.$route.path
      if (path == '/notice') {
        this.$router.push('/notice')
        this.activePath = 'notice'
        return false
      }
      this.activePath = 'basicmanager'
    },

    // 退出登陆
    async unLogin() {
      // const confirResult = await this.$confirm('您确定要退出吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // }).catch((err) => err)
      // if (confirResult !== 'confirm') {
      //   return this.$message.info('已取消！！')
      // }
      // const res = await UserLogout()
      // localStorage.clear()
      // sessionStorage.clear()
      // this.$router.push('/user/login')
      // let urls = this.url + 'user/login'
      let urls = localStorage.getItem('url')
      // let urls = this.url
      window.open(urls, '_self')
    },

    // 修改密码
    xgpassword() {
      this.visible = true
    },
    cancelpass() {
      this.visible = false
      this.resetForm('passform')
    },
    resetForm(form) {
      this.$refs[form].resetFields()
    },
    workTai() {
      let urlss = localStorage.getItem('url') + '#/home?token=' + localStorage.getItem('token')
      window.open(urlss, '_self')
    },

    checkPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error('二次密码不能为空'))
      } else {
        if (this.passform.newPassword !== this.passform.newPassword1) {
          return callback(new Error('两次密码必须输入一致'))
        } else {
          callback()
        }
      }
    },
    submitpass() {
      this.$refs.passform.validate((valid) => {
        if (valid) {
          this.ApiModifyPassByOld()
        } else {
          this.$message.error('请检查信息是否填写正确')
          return false
        }
      })
    },
    ApiModifyPassByOld() {
      const { passform } = this
      modifyPassWord({ ...passform }).then((res) => {
        this.$message.success('修改成功,下次登录请使用先密码登录')
        this.visible = false
        this.resetForm('passform')
      })
    },
    // 处理路由刷新跳转
    toRouter() {
      // const path = this.$router.path
      // if (path == '/notice') {
      //   this.$router.push('/notice')
      //   this.activePath = 'notice'
      //   return false
      // }
      // this.activePath = 'basicmanager'
    },
    navTo(item) {
      if (item.appId == 13) return
      let html =
        item.appUrl +
        '?roleId=' +
        localStorage.getItem('roleId') +
        '&token=' +
        localStorage.getItem('token')+'&url='+localStorage.getItem('url')
      window.open(html, '_self')
    },
    getAppList() {
      let params = {
        id: localStorage.getItem('roleId'),
      }
      getAppList(params).then((res) => {
        if (res.data.code == 0) {
          this.appList = res.data.data
        }
      })
    },
  },

  computed: {},
}
</script>
<style>
.el-popover {
  min-width: 80px !important;
  top: 50px !important;
}
.popper__arrow {
  left: 75% !important;
}
</style>
<style scoped>
.el-container {
  height: 100vh;
  position: relative;
}
.el-header {
  height: 60px !important;
  line-height: 60px;
  background: #006eff;
  color: #fff;
  display: flex;
  justify-content: space-between;
}
.header_text {
  display: flex;
  justify-content: left;
}
.herder_text_left {
  display: flex;
  align-items: center;
  font-size: 18px !important;
  font-weight: 600;
  color: #ffffff;
}

.herder_text_left .logo {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  margin-right: 15px;
}

/* 头部左侧区域 */
.herder_text_left {
  font-size: 20px;
  line-height: 80px;
}

.herder_text_right ul {
  width: 180px;
  display: flex;
  justify-content: space-between;
  line-height: 80px;
}

.herder_text_right li {
  list-style: none;
  display: inline-block;
  font-size: 14px;
}

/* 头部右侧区域 */
.header_right {
  display: flex;
}

.header_right ul {
  display: flex;
  justify-content: space-between;
}

.header_right li {
  line-height: 80px;
  list-style: none;
  font-size: 14px;
  display: inline-block;
}

.header_right_se li {
  list-style: none;
  height: 60px;
  font-size: 14px;
  line-height: 60px;
  text-align: center;
  margin-bottom: 10px;
}

.hearder_right_user {
  cursor: pointer;
  float: right;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
}
.hearder_right_user .img-box {
  height: 100%;
  line-height: 60px;
  display: flex;
  align-items: center;
  margin-right: 24px;
}

.imglogo {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 50%;
}
.username {
  float: right;
  font-size: 14px;
  height: 60px;
  line-height: 60px;
}

.header_right_se li {
  cursor: pointer;
  list-style: none;
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
}
.header_right_se li:hover {
  background-color: #e1efff;
}
.header_btny {
  float: left;
  /* margin-top: 6px;
  margin-right: 15px; */
  margin: 6px 15px 0 0;
}
/* 头部结束 */

.usernames {
  float: left;
  display: inline-block;
  width: 60px;
  font-size: 14px;
  /* margin-top: 10px; */
  margin-left: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.popovername {
  height: 40px;
  line-height: 40px;
  padding: 0 32px;
}
.el-divider {
  margin: 10px 0;
}

.nowApp {
  position: relative;
}
.nowApp::after {
  content: '';
  position: absolute;
  width: 100%;
  background-color: #fff;
  height: 3px;
  left: 0;
  bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/views/basisdata/basis.vue